module.exports = __webpack_public_path__ + "img/promo-banner.16598fec.png";